import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Connects } from '../connects';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConnectsService } from '../../../services/connects.service';
import { BehaviorSubject } from 'rxjs';
import { DataServiceService } from '../../../services/data-service.service';
import { ConnectsPagination } from '../connects-interface';

@Component({
  selector: 'app-mobile-admin',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './mobile-admin.component.html',
  styleUrl: './mobile-admin.component.scss',
})
export class MobileAdminComponent implements OnInit {
  public pageNumbers: number[] = [];
  public totalPages: number;
  public connects: Connects[];
  connect = {} as Connects;
  searchName = '';
  page = 1;
  @Input()
  connectsDataSource: BehaviorSubject<ConnectsPagination> =
    new BehaviorSubject<ConnectsPagination>({ content: [], pageable: { pageNumber: 0 }, totalPages: 0 });
  constructor(private readonly dataServiceService: DataServiceService,
  private readonly connectService: ConnectsService
  ) {}

  public ngOnInit(): void {
    this.getConnects();
  }
  public getConnects() {
    this.dataServiceService.setListOptionUpdate({
      searchName: this.searchName,
      page: this.page,
    });
    this.connectsDataSource.subscribe(
      (data: {
        content: Connects[];
        pageable: { pageNumber: number };
        totalPages: number;
      }) => {
        this.connects = data.content;
        if (this.connectsDataSource) {
          if (data.pageable?.pageNumber >= 0) {
            this.pageNumbers = Array.from(
              { length: data.totalPages },
              (_, i) => i + 1
            );
          }
          this.totalPages = data.totalPages;
        }
      }
    );
  }
  public adminDetails(connect: Connects) {
    this.connect = connect;
  }
  public getPage(item) {
    this.page = item;
    this.getConnects();
  }
  public next() {
    this.page = this.page + 1;
    this.getConnects();
  }
  public previous() {
    this.page = this.page - 1;

    this.getConnects();
  }
  public onSubmit() {
    this.connectService.checkIn(this.connect.id, this.connect).subscribe();
  }
}
